export default function getAppointmentType() {
  let type = "BEAUTY_ADVISOR";
  const urlParams = new URLSearchParams(window.location.search);
  const varUrl = urlParams.get("type");
  if (varUrl === "1") {
    type = "BEAUTY_ADVISOR";
  } else if (varUrl === "2") {
    type = "CLICK_IN_STORE";
  }
  return type;
}
